import React, { useState, useEffect, useRef } from "react";
import UploadIn from '../../assets/images/icon/UploadIp.svg';
import Row from 'react-bootstrap/Row';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { CheckboxWithLabel, TextField, } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError, mixed } from 'yup';
import { Form as RBFORM } from 'react-bootstrap';
import {
  Box,
  Button,
  CircularProgress,
  colors,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Grid from "@mui/material/Grid2";
import Stack from '@mui/material/Stack';
import { getMethod, postMethod, postMethodFormData } from "../../../services/apiService";
import * as Yup from "yup";
import { getPartnetId, getUserPriority, getSessionUser } from "../../../services/authService";
import { ToastContext, useToastContext } from "../../../context/toastContext";
import { useNavigate } from "react-router-dom";
import { clearStorageAndCookies } from "../../../services/authService";
import { getCountriesAPI, getStatesAPI, getCitiesAPI } from "../../../services/placeService";
import { AlertDialogs } from "../../dialogs/alertDialogs";
import { PROFILE_TYPE } from "../../../helper/globalConstant";
import { allTimezones } from "react-timezone-select";
import noteIcon from "../../../assets/images/noteIcon.svg";


function OrderCreateStep1SiteDevice(props: any) {
  const { setToast } = useToastContext() as ToastContext;
  const navigate = useNavigate();
  const [siteType, setSiteType] = useState("1")
  const [customers, setCustomers] = useState([]);
  const [userPriority, setUserPriority] = useState<number | undefined>(getUserPriority());
  const [enterpriseId, setEnterpriseId] = useState<any>();
  const [sites, setSites] = useState([]);
  const [partnerId, setPartnerId] = useState<any>();
  const [selectedCustomer, setSelectedCustomer] = useState(props.step1FormValues?.customer || "")
  const [countryList, setCountryList] = useState<any[]>([]);
  const [country, setCountry] = useState("");
  const [stateList, setStateList] = useState<any[]>([]);
  const [filteredStateList, setFilteredStateList] = useState<any[]>(props.filteredStateList || []);
  const [state, setState] = useState("");
  const [cityList, setCityList] = useState<any[]>([]);
  const [filteredCityList, setFilteredCityList] = useState<any[]>(props.filteredCityList || []);
  const [city, setCity] = useState("");
  const [customerTimeZone, setCustomerTimeZone] = useState("");
  const [customerSiteList, setCustomerSiteList] = useState<any[]>([]);
  const isUserInitiatedRef = useRef(false);

  function getTimezoneOffset(zone: string) {
    const now = new Date();
    const formatter = new Intl.DateTimeFormat("en-US", {
      timeZone: zone,
      hour12: false,
      hour: "2-digit",
      minute: "2-digit",
    });

    const parts = formatter.formatToParts(now);
    const localHour = Number(parts.find((p) => p.type === "hour")?.value);
    const localMinute = Number(parts.find((p) => p.type === "minute")?.value);

    const utcHour = now.getUTCHours();
    const utcMinute = now.getUTCMinutes();

    const totalMinutes = (localHour * 60 + localMinute) - (utcHour * 60 + utcMinute);
    return totalMinutes;
  }

  function formatOffset(minutes: number) {
    const sign = minutes >= 0 ? "+" : "-";
    const abs = Math.abs(minutes);
    const hours = String(Math.floor(abs / 60)).padStart(2, "0");
    const mins = String(abs % 60).padStart(2, "0");
    return `UTC${sign}${hours}:${mins}`;
  }

  const timezoneList = Object.keys(allTimezones).map((zone) => {
    const offsetInMinutes = getTimezoneOffset(zone);
    const formatted = formatOffset(offsetInMinutes);

    return {
      label: `(${formatted}) ${zone}`,
      value: zone,
    };
  });

  const handleSiteChange = async (e: any, setFieldValue: any) => {
    const selectedSite = e.target.value; // Assume it's an object with name and id
    setFieldValue("siteId", selectedSite)
    const siteData: any = customerSiteList?.find((item: any) => item?.siteId == selectedSite);
    props.setSiteInfo(siteData);
    setOrderInitial((prvData: any) => ({
      ...prvData,
      siteId: selectedSite
    }));
  }


  const handleSelectCustomer = async (e: any, setFeildValue: any) => {
    const selectedCustomer = e.target.value; // Assume it's an object with name and id
    const cumstomerInfo: any = customers.find((customer: any) => customer.name === selectedCustomer);
    if (cumstomerInfo) {

      setFeildValue("enterpriseid", cumstomerInfo.id); // Access id only if cumstomerInfo is not undefined
      setEnterpriseId(cumstomerInfo.id);
      setCustomerTimeZone(cumstomerInfo.timezone);
    }
    setSelectedCustomer(selectedCustomer); // Set the customer name
  };

  useEffect(() => {
    const priority = getUserPriority();
    setUserPriority(priority);
    fetchCustomerList();
    fetchPartnerId();
    getCountryList();
    getStateList();
    getCityList();
  }, []);


  const getCountryList = async () => {
    const resp = await getCountriesAPI();
    console.log("getCountryList resp:", resp);
    setCountryList(resp.countries);
  }


  const getStateList = async () => {
    const resp = await getStatesAPI();
    console.log("getStateList resp:", resp);
    setStateList(resp.states);
  }


  const getCityList = async () => {
    const resp = await getCitiesAPI();
    console.log("getCityList resp:", resp);
    setCityList(resp.cities);
  }


  const handleCountryChange = async (e: any, setFieldValue: any) => {
    const selectedCountryId = e.target.value;
    console.log("handleCountryChange triggered! selectedCountryId:", selectedCountryId);
    console.log("Available countryList count:", countryList?.length);
    console.log("Available stateList count:", stateList?.length);

    const selectedCountry = countryList.find((country: any) => country.id.toString() === selectedCountryId) || { id: '', name: '', shortname: '' };
    console.log("Resolved selectedCountry:", selectedCountry);

    setCountry(selectedCountry.id === '' || selectedCountry.id === '0' ? '' : selectedCountry.name);
    setFieldValue("country", selectedCountry.id.toString());
    setFieldValue("state", "");
    setFieldValue("city", "");
    setState("");
    setCity("");
    setFilteredCityList([]);
    props.setFilteredCityList([]);

    setTimeout(() => {
      const filteredStates = stateList.filter((state: any) => state.country_id.toString() === selectedCountry.id.toString());
      console.log("Filtered states count:", filteredStates?.length);
      props.setFilteredStateList(filteredStates);
      setFilteredStateList(filteredStates);
    }, 200);
  }


  const handleStateChange = async (e: any, setFieldValue: any) => {
    const selectedStateId = e.target.value;
    const selectedState = stateList.find((state: any) => state.id.toString() === selectedStateId) || { id: '', name: '', country_id: '' };
    setState(selectedState.id === '' || selectedState.id === '0' ? '' : selectedState.name);
    setFieldValue("state", selectedState.id.toString());
    setFieldValue("city", "");
    setCity("");

    setTimeout(() => {
      const filteredCities = cityList.filter((city: any) => city.state_id.toString() === selectedState.id.toString());
      props.setFilteredCityList(filteredCities);
      setFilteredCityList(filteredCities);
    }, 200);
  }


  const handleCityChange = async (e: any, setFieldValue: any) => {
    const selectedCityId = e.target.value;
    const selectedCity = cityList.find((country: any) => country.id.toString() === selectedCityId) || { id: '', name: '', state_id: '' };
    setCity(selectedCity.id === '' || selectedCity.id === '0' ? '' : selectedCity.name);
    setFieldValue("city", selectedCity.id.toString());
  }


  const handleTimeZoneChange = async (e: any, setFieldValue: any) => {

    setCustomerTimeZone(e.target.value);
    setFieldValue("timezone", e.target.value);
  }

  const fetchPartnerId = async () => {
    const id = await getPartnetId();
    setPartnerId(id);
  }


  useEffect(() => {
    if (userPriority !== PROFILE_TYPE.DISTRIBUTOR && enterpriseId !== undefined && partnerId !== undefined) {
      fetchSiteDevice();
    }
  }, [enterpriseId, partnerId, userPriority]);



  const fetchSiteDevice = async () => {
    let partnerInfo = partnerId;

    const sess_user = getSessionUser();
    if (sess_user) {
      const extractedProfileId = sess_user?.userProfile;
      if (extractedProfileId) {
        const priority = extractedProfileId?.priority;
        if (priority === PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G1 || priority === PROFILE_TYPE.INTEGRATOR_TECHNICIAN_G2) {
          partnerInfo = extractedProfileId?.ownerId;
        }
      } else {
        console.error("Priority id not found in userProfile");
      }
    }

    try {
      const resp = await getMethod("/customer/site/siteswithoutorders/partnerid/" + partnerInfo + "/enterpriseid/" + enterpriseId);

      if (resp?.status === 200) {
        const siteDetails = resp?.data?.result.map((site: { name: any; siteId: any; }) => ({
          name: site.name,
          siteId: site.siteId,
        }));

        setCustomerSiteList(resp?.data?.result);
        props.setCustomerWiseSiteList(siteDetails);
        setSites(siteDetails)
      } else {
        setToast(resp?.data?.message, "error");
      }
    } catch (error) {
      console.error("Error fetching customer list:", error);
    }
  }



  const fetchCustomerList = async () => {
    try {
      const priority = getUserPriority();
      if (priority === PROFILE_TYPE.DISTRIBUTOR) {
        const resp = await getMethod("partner/partnerswithoutorders");

        if (resp?.status === 200) {
          let cus = resp?.data?.result?.map((item: any) => {
            const fullName = `${item.name || ""} ${item.lastName || ""}`.trim();
            return {
              name: fullName || item.userId,
              id: item.userId,
              timezone: item.timezone || "Asia/Kolkata",
            };
          });
          setCustomers(cus);
        } else {
          setToast(resp?.data?.message, "error");
        }
      } else {
        const resp = await getMethod("customer");
        if (resp?.status === 200) {
          let cus = resp?.data?.result?.map((item: any) => ({
            name: item.vEnterprise?.name,
            id: item.vEnterprise?.enterpriseid,
            timezone: item.vEnterprise?.timezone,
            address: item.vEnterprise?.address,
            contact: item.vEnterprise?.contact,
          }));
          setCustomers(cus);
        } else {
          setToast(resp?.data?.message, "error");
        }
      }
    } catch (error) {
      console.error("Error fetching customer/partner list:", error);
    }
  };


  const [orderInitial, setOrderInitial] = useState({
    "customer": '',
    "orderName": '',
    "orderRef": '',
    "siteId": '',
    "enterpriseid": '',
  });


  const validationSchemaForOrder = Yup.object({
    customer: Yup.string().nullable().required(userPriority === PROFILE_TYPE.DISTRIBUTOR ? "Partner is required!" : "Customer is required!"),
    orderName: Yup.string().trim().required("Order name is required!"),
    orderRef: Yup.string().trim().required("Order Reference is required!"),
    siteId: userPriority === PROFILE_TYPE.DISTRIBUTOR
      ? Yup.number().optional()
      : Yup.number().required("Site id is required!"),
  });


  const emptySiteInitial = {
    "orderName": '',
    "orderRef": '',
    "customer": '',
    "enterpriseid": enterpriseId,
    "name": '',
    "uniqueid": '',
    "email": '',
    "type": 'EDGE',
    "addressline1": '',
    "addressline2": '',
    "postalcode": '',
    "city": '',
    "state": '',
    "country": '',
    "timezone": customerTimeZone,
    "mobile": '',
    "number": '',
  };

  const [siteInitial, setSiteInitial] = useState(emptySiteInitial);

  const validationSchemaForSite = Yup.object({
    orderName: Yup.string().trim().required("Order name is required!"),
    orderRef: Yup.string().trim().required("Order Reference is required!"),
    customer: Yup.string().trim().required("Customer is required!"),
    enterpriseid: Yup.string().trim().required("Enterprise ID is required!"),
    name: Yup.string().trim().required("Site name is required!"),
    uniqueid: Yup.string().trim().required("Unique ID is required!"),
    // email: Yup.string().email().required("Email ID is required!"),
    type: Yup.string().required("Type is required!"),
    number: string().trim().matches(/^\d{2,10}$/, "Number must be between 2 to 10 digits").optional(),
    addressline1: Yup.string().trim().optional(),
    postalcode: Yup.string().trim().optional(),
    city: Yup.string().trim().optional(),
    state: Yup.string().trim().optional(),
    country: Yup.string().trim().optional(),
  });

  useEffect(() => {
    if (partnerId !== undefined) setOrderInitial(prvdata => ({ ...prvdata, partnerId: partnerId }));
  }, [partnerId]);


  const handleOrderName = (value: string, setFeildValue: any, siteType: string, setFieldError?: any) => {
    setFeildValue("orderName", value);
    if (value && setFieldError) {
      setFieldError("orderName", undefined);
    }

    if (siteType === "1") {
      setOrderInitial((prvData: any) => {
        return { ...prvData, orderName: value }
      })
    } else {
      setSiteInitial((prvData: any) => {
        return { ...prvData, orderName: value }
      })
    }
  }


  const handleOrderRef = (value: string, setFeildValue: any, siteType: string, setFieldError?: any) => {
    setFeildValue("orderRef", value);
    if (value && setFieldError) {
      setFieldError("orderRef", undefined);
    }

    if (siteType === "1") {
      setOrderInitial((prvData: any) => {
        return { ...prvData, orderRef: value }
      })
    } else {
      setSiteInitial((prvData: any) => {
        return { ...prvData, orderRef: value }
      })
    }
  }




  const handleSiteTypeChange = (site: any, values: any) => {
    if (site === "1") {
      setOrderInitial((prvData: any) => {
        return { 
          ...prvData, 
          orderRef: values.orderRef, 
          orderName: values.orderName,
          customer: values.customer || '',
          enterpriseid: values.enterpriseid || ''
        }
      })
    } else {
      setSiteInitial((prvData: any) => {
        return { 
          ...prvData, 
          orderRef: values.orderRef, 
          orderName: values.orderName,
          customer: values.customer || '',
          enterpriseid: values.enterpriseid || ''
        }
      })
    }
    props.setSiteType(site);
    setSiteType(site);
  };


  const [open, setOpen] = React.useState(false);
  const getConfirmResponse = (action: string) => {
    if (action === 'Exit') {
      navigate('/orders');
    } else if (action === 'Continue Editing') {
      setOpen(false);
    }
  }

  // Automatically filter states when countryList or stateList is loaded and an initial country is set
  useEffect(() => {
    let initialCountry = siteInitial.country;
    if (initialCountry && countryList?.length > 0 && stateList?.length > 0) {
      if (isNaN(Number(initialCountry))) {
        const countryObj: any = (countryList as any[]).find(
          (c: any) => c.name.trim().toLowerCase() === initialCountry.trim().toLowerCase()
        );
        initialCountry = countryObj ? countryObj.id.toString() : "";
      }
      if (initialCountry) {
        const filtered = (stateList as any[]).filter((state: any) => state.country_id.toString() === initialCountry.toString());
        setFilteredStateList(filtered);
        props.setFilteredStateList(filtered);
      }
    }
  }, [countryList, stateList, siteInitial.country, siteType]);

  // Automatically filter cities when stateList or cityList is loaded and an initial state is set
  useEffect(() => {
    let initialState = siteInitial.state;
    let initialCountry = siteInitial.country;
    if (initialState && stateList?.length > 0 && cityList?.length > 0) {
      if (initialCountry && isNaN(Number(initialCountry)) && countryList?.length > 0) {
        const countryObj: any = (countryList as any[]).find(
          (c: any) => c.name.trim().toLowerCase() === initialCountry.trim().toLowerCase()
        );
        initialCountry = countryObj ? countryObj.id.toString() : "";
      }
      if (isNaN(Number(initialState))) {
        const stateObj: any = (stateList as any[]).find(
          (s: any) =>
            s.name.trim().toLowerCase() === initialState.trim().toLowerCase() &&
            (!initialCountry || s.country_id.toString() === initialCountry.toString())
        );
        initialState = stateObj ? stateObj.id.toString() : "";
      }
      if (initialState) {
        const filtered = (cityList as any[]).filter((city: any) => city.state_id.toString() === initialState.toString());
        setFilteredCityList(filtered);
        props.setFilteredCityList(filtered);
      }
    }
  }, [countryList, stateList, cityList, siteInitial.state, siteInitial.country, siteType]);

  // Sync filtered lists with parent props to prevent state loss on remount
  useEffect(() => {
    if (props.filteredStateList?.length > 0) {
      setFilteredStateList(props.filteredStateList);
    }
  }, [props.filteredStateList]);

  useEffect(() => {
    if (props.filteredCityList?.length > 0) {
      setFilteredCityList(props.filteredCityList);
    }
  }, [props.filteredCityList]);

  // Synchronize customer details and resolve geographic IDs reactively
  useEffect(() => {
    if (siteType === "2" && selectedCustomer && customers?.length > 0) {
      if (props.step1FormValues && !isUserInitiatedRef.current) {
        return;
      }
      const customerInfo = customers.find((c: any) => c.name === selectedCustomer) as any;
      if (customerInfo) {
        const newEnterpriseId = customerInfo.id;
        
        let country_id = customerInfo?.address?.country || "";
        if (country_id && isNaN(Number(country_id)) && countryList?.length > 0) {
          const countryObj: any = (countryList as any[]).find(
            (c: any) => c.name.trim().toLowerCase() === country_id.trim().toLowerCase()
          );
          country_id = countryObj ? countryObj.id.toString() : "";
        }

        let state_id = customerInfo?.address?.state || "";
        if (state_id && isNaN(Number(state_id)) && stateList?.length > 0) {
          const stateObj: any = (stateList as any[]).find(
            (s: any) =>
              s.name.trim().toLowerCase() === state_id.trim().toLowerCase() &&
              (!country_id || s.country_id.toString() === country_id.toString())
          );
          state_id = stateObj ? stateObj.id.toString() : "";
        }

        let city_id = customerInfo?.address?.city || "";
        if (city_id && isNaN(Number(city_id)) && cityList?.length > 0) {
          const cityObj: any = (cityList as any[]).find(
            (c: any) =>
              c.name.trim().toLowerCase() === city_id.trim().toLowerCase() &&
              (!state_id || c.state_id.toString() === state_id.toString())
          );
          city_id = cityObj ? cityObj.id.toString() : "";
        }

        if (countryList?.length > 0 && stateList?.length > 0 && country_id) {
          const filteredStates = (stateList as any[]).filter(
            (state: any) => state.country_id.toString() === country_id.toString()
          );
          setFilteredStateList(filteredStates);
          props.setFilteredStateList(filteredStates);
        }

        if (stateList?.length > 0 && cityList?.length > 0 && state_id) {
          const filteredCities = (cityList as any[]).filter(
            (city: any) => city.state_id.toString() === state_id.toString()
          );
          setFilteredCityList(filteredCities);
          props.setFilteredCityList(filteredCities);
        }

        setCountry(customerInfo?.address?.country || "");
        setState(customerInfo?.address?.state || "");
        setCity(customerInfo?.address?.city || "");
        setEnterpriseId(newEnterpriseId);
        setCustomerTimeZone(customerInfo.timezone);

        setSiteInitial((prvData: any) => ({
          ...prvData,
          customer: selectedCustomer,
          enterpriseid: newEnterpriseId,
          addressline1: customerInfo?.address?.addressline1 || "",
          addressline2: customerInfo?.address?.addressline2 || "",
          postalcode: customerInfo?.address?.postalcode || "",
          country: country_id,
          state: state_id,
          city: city_id,
          number: customerInfo?.contact?.phone?.number || "",
          timezone: customerInfo.timezone || prvData.timezone,
        }));
      }
    }
  }, [selectedCustomer, customers, countryList, stateList, cityList, siteType]);

  useEffect(() => {
    if (props.step1FormValues) {
      const resolvedSiteType = props.siteType || "1";
      if (resolvedSiteType === "1") {
        setSiteType("1");
        if (props.siteInfo) {
          setEnterpriseId(props.step1FormValues.enterpriseid);
          setPartnerId(props.step1FormValues.partnerId);
        }
        setSites(props.customerWiseSiteList);
        setOrderInitial(prvData => ({
          ...prvData,
          customer: props.step1FormValues.customer,
          enterpriseid: props.step1FormValues.enterpriseid,
          orderName: props.step1FormValues.orderName,
          orderRef: props.step1FormValues.orderRef,
          siteId: props.step1FormValues.siteId,
        }));
      } else if (resolvedSiteType === "2" && countryList.length > 0 && stateList.length > 0 && cityList.length > 0) {
        setSiteType("2");
        if (props.siteInfo) {
          setEnterpriseId(props.step1FormValues.enterpriseid);
          setPartnerId(props.step1FormValues.partnerId);
        }
        setSelectedCustomer(props.step1FormValues.customer || "");
        isUserInitiatedRef.current = false;

        // Resolve names to IDs
        let country_id = props.step1FormValues.country || "";
        if (country_id && isNaN(Number(country_id))) {
          const countryObj: any = (countryList as any[]).find(
            (c: any) => c.name.trim().toLowerCase() === country_id.trim().toLowerCase()
          );
          country_id = countryObj ? countryObj.id.toString() : "";
        }

        let state_id = props.step1FormValues.state || "";
        if (state_id && isNaN(Number(state_id))) {
          const stateObj: any = (stateList as any[]).find(
            (s: any) =>
              s.name.trim().toLowerCase() === state_id.trim().toLowerCase() &&
              (!country_id || s.country_id.toString() === country_id.toString())
          );
          state_id = stateObj ? stateObj.id.toString() : "";
        }

        let city_id = props.step1FormValues.city || "";
        if (city_id && isNaN(Number(city_id))) {
          const cityObj: any = (cityList as any[]).find(
            (c: any) =>
              c.name.trim().toLowerCase() === city_id.trim().toLowerCase() &&
              (!state_id || c.state_id.toString() === state_id.toString())
          );
          city_id = cityObj ? cityObj.id.toString() : "";
        }

        setCountry(props.step1FormValues.country || "");
        setState(props.step1FormValues.state || "");
        setCity(props.step1FormValues.city || "");

        if (country_id) {
          const filteredStates = stateList.filter(
            (state: any) => state.country_id.toString() === country_id.toString()
          );
          setFilteredStateList(filteredStates);
          props.setFilteredStateList(filteredStates);
        } else {
          setFilteredStateList([]);
          props.setFilteredStateList([]);
        }

        if (state_id) {
          const filteredCities = cityList.filter(
            (city: any) => city.state_id.toString() === state_id.toString()
          );
          setFilteredCityList(filteredCities);
          props.setFilteredCityList(filteredCities);
        } else {
          setFilteredCityList([]);
          props.setFilteredCityList([]);
        }

        setSiteInitial(prvData => ({
          ...prvData,
          orderName: props.step1FormValues.orderName || prvData.orderName || '',
          orderRef: props.step1FormValues.orderRef || prvData.orderRef || '',
          customer: props.step1FormValues.customer || prvData.customer || '',
          enterpriseid: props.step1FormValues.enterpriseid || prvData.enterpriseid || '',
          name: props.step1FormValues.name || prvData.name || '',
          uniqueid: props.step1FormValues.uniqueid || prvData.uniqueid || '',
          type: props.step1FormValues.type || prvData.type || 'EDGE',
          email: props.step1FormValues.email || prvData.email || '',
          addressline1: props.step1FormValues.addressline1 || prvData.addressline1 || '',
          addressline2: props.step1FormValues.addressline2 || prvData.addressline2 || '',
          country: country_id || prvData.country || '',
          state: state_id || prvData.state || '',
          city: city_id || prvData.city || '',
          postalcode: props.step1FormValues.postalcode || prvData.postalcode || '',
          mobile: props.step1FormValues.mobile || prvData.mobile || '',
          number: props.step1FormValues.number || prvData.number || '',
          timezone: props.step1FormValues.timezone || prvData.timezone || customerTimeZone,
        }));
      }
    }
  }, [props.step1FormValues, props.siteType, countryList, stateList, cityList]);


  // console.log(sites)
  return (
    <>
      <Formik initialValues={siteType === "1" ? orderInitial : siteInitial}
        enableReinitialize={true} // Enable reinitialization
        validationSchema={siteType === "1" ? validationSchemaForOrder : validationSchemaForSite}
        onSubmit={async (values, { setSubmitting }) => {

          console.log("Form Values ==== >>>")
          console.log(values)

          if (siteType === "1") {
            let tmp_values: any = { ...values };
            tmp_values['partnerId'] = userPriority === PROFILE_TYPE.DISTRIBUTOR ? (values as any).enterpriseid : partnerId;
            props.setStep1FormValues(tmp_values);
            props.setOrderInfo(tmp_values)
            props.setActiveStep(1);
          } else if (siteType === "2") {
            let tmp_values: any = { ...values };
            //let tmp_values2: any = { ...values };
            //console.log("values", tmp_values2);
            tmp_values.country = country;
            tmp_values.state = state;
            tmp_values.city = city;
            tmp_values.timezone = customerTimeZone;
            tmp_values.redirecturl = "/auth/set-password?uk=";
            const formData = new FormData();
            Object.keys(tmp_values).map(item => {
              formData.append(item, tmp_values[item]);
            })

            const resp = await postMethodFormData("customer/site", formData);
            console.log(resp)
            if (resp?.status === 200) {
              const newSite = resp?.data?.result?.[0];
              const newSiteId = newSite?.siteId;
              tmp_values['siteId'] = newSiteId;
              tmp_values['partnerId'] = partnerId;
              console.log(tmp_values);
              props.setSiteInfo(newSite);
              props.setOrderInfo(tmp_values);
              props.setStep1FormValues(tmp_values);

              // Instantly update parent's customer-wise site list with the new site!
              const siteDetail = {
                name: newSite?.name || tmp_values.name,
                siteId: newSiteId,
              };
              const updatedList = [...(props.customerWiseSiteList || []), siteDetail];
              props.setCustomerWiseSiteList(updatedList);

              // Update siteType to "1" (existing) in parent and locally
              props.setSiteType("1");
              setSiteType("1");

              props.setActiveStep(1);
            } else {
              setToast(resp?.data?.message, "error");
            }
          }
        }}


      >

        {({ values, errors, isSubmitting, isValid, setFieldValue, touched, setFieldError, setValues }) => (
          <React.Fragment>
            <ToastContainer />
            <Form autoComplete="off" style={{ marginBottom: "150px" }}>
              <Row className="mb-3">
                <Grid container spacing={3}>
                  <Grid size={{ xs: 12, md: 6 }}>
                    <RBFORM.Group>
                      <RBFORM.Label className="label">Order Name<span style={{ color: "red" }}>*</span></RBFORM.Label>
                      <Field
                        name="orderName"
                        type="text"
                        placeholder="Enter Order Name"
                        component={TextField}
                        className="inputC"
                        onChange={(e: any) => handleOrderName(e.target.value, setFieldValue, siteType, setFieldError)}
                      />
                    </RBFORM.Group>
                  </Grid>

                  <Grid size={{ xs: 12, md: 6 }}>
                    <RBFORM.Group>
                      <RBFORM.Label className="label">Order Reference<span style={{ color: "red" }}>*</span></RBFORM.Label>
                      <Field
                        name="orderRef"
                        type="text"
                        placeholder="Enter Order Reference"
                        component={TextField}
                        className="inputC"
                        onChange={(e: any) => handleOrderRef(e.target.value, setFieldValue, siteType, setFieldError)}
                      />
                    </RBFORM.Group>
                  </Grid>
                </Grid>
              </Row>
              <Row className="mb-3" style={{ marginTop: '30px' }}>
                <Grid container className="titleTagIo1" spacing={3} style={{ fontSize: "20px", marginBottom: "20px" }}>
                  {userPriority === PROFILE_TYPE.DISTRIBUTOR ? "Select Partner" : (siteType === "1" ? "Select Customer" : "Customer Details")}
                </Grid>
              </Row>
              {siteType === "1" &&
                <Row className="mb-3">
                  <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>

                      <RBFORM.Group>
                        <RBFORM.Label className="label">{userPriority === PROFILE_TYPE.DISTRIBUTOR ? "Select Partner" : "Select Customer"}<span style={{ color: "red" }}>*</span></RBFORM.Label>
                        <Field
                          name="customer"
                          as="select"
                          placeholder={userPriority === PROFILE_TYPE.DISTRIBUTOR ? "Select Partner" : "Select Customer"}
                          className="inputC custDropdown"
                           onChange={(e: any) => {
                             const val = e.target.value;
                             const customerInfo = customers.find((c: any) => c.name === val) as any;
                             const newEnterpriseId = customerInfo ? customerInfo.id : "";
                             
                             setValues({
                               ...values,
                               customer: val,
                               enterpriseid: newEnterpriseId
                             });

                             setOrderInitial((prvData: any) => ({
                               ...prvData,
                               customer: val,
                               enterpriseid: newEnterpriseId
                             }));

                             if (val) {
                               setFieldError("customer", undefined);
                             }

                              if (customerInfo) {
                                setEnterpriseId(customerInfo.id);
                                setCustomerTimeZone(customerInfo.timezone);
                              }
                              isUserInitiatedRef.current = true;
                              setSelectedCustomer(val);
                           }}
                           style={{ marginBottom: '10px !important' }}
                        >
                          <option value=''>{userPriority === PROFILE_TYPE.DISTRIBUTOR ? "Select Partner" : "Select Customer"}</option>
                          {customers?.length > 0 &&
                            customers.map((customer: any) => (
                              <option key={customer.id} value={customer.name}>
                                {customer.name}
                              </option>
                            ))
                          }
                        </Field>
                        <ErrorMessage name="customer">{(error) => <Typography style={{ color: '#f44336', fontSize: "11px", marginTop: "-18px", marginBottom: "10px" }}>{error}</Typography>}</ErrorMessage>
                      </RBFORM.Group>
                    </Grid>
                  </Grid>
                </Row>
              }
              {userPriority !== PROFILE_TYPE.DISTRIBUTOR && (
                <>
                  <Row className="mb-3">
                    <Grid container spacing={3}>
                      <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{ mb: 2, mt: 4 }} style={{ backgroundColor: "#192529", borderRadius: "30px", color: "#E2E3E3", fontSize: "14px" }}>

                          <RadioGroup
                            name="validity"
                            row
                            value={siteType}
                            onChange={(e: any) => handleSiteTypeChange(e.target.value, values)}
                          >
                            <FormControlLabel value="1" control={<Radio />} label="Existing Site / Device" />
                            <FormControlLabel value="2" control={<Radio />} label="New Site / Device" />
                          </RadioGroup>
                        </Box>
                      </Grid>


                    </Grid>
                  </Row>

                  {siteType == "1" ?
                    <Row className="mb-3">
                      <Grid container spacing={3}>
                        <Grid size={{ xs: 12, md: 6 }}>

                          <RBFORM.Group>
                            <RBFORM.Label className="label">Select Existing Site / Device<span style={{ color: "red" }}>*If the Site/Device is not displayed for this customer, there is already an active order.  Modify the existing Site/Device Order on the Orders Page. </span></RBFORM.Label>
                            <Field
                              name="siteId"
                              as="select"
                              placeholder="Select Customer"
                              className="inputC custDropdown"
                              onChange={(e: any) => handleSiteChange(e, setFieldValue)}
                            >
                              <option value=''>Select Site / Device</option>
                              {sites?.length > 0 &&
                                sites.map((site: any) => (
                                  <option key={site.siteId} value={site.siteId}>
                                    {site.name}
                                  </option>
                                ))
                              }
                            </Field>
                            <ErrorMessage name="siteId">{(error) => <Typography style={{ color: '#f44336', fontSize: "11px", marginTop: "-18px", marginBottom: "10px" }}>{error}</Typography>}</ErrorMessage>
                          </RBFORM.Group>
                        </Grid>


                      </Grid>

                    </Row> : <>
                      {/* {JSON.stringify(values, null, 2)} */}
                      <Row>
                        <Grid container spacing={3}>
                          <Grid size={{ xs: 12, md: 6 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Select Customer<span style={{ color: "red" }}>*</span></RBFORM.Label>
                              <Field
                                name="customer"
                                as="select"
                                placeholder="Select customer"
                                className="inputC custDropdown"
                                onChange={(e: any) => {
                                  const val = e.target.value;
                                  const customerInfo = customers.find((c: any) => c.name === val) as any;
                                  const newEnterpriseId = customerInfo ? customerInfo.id : "";
                                  
                                  isUserInitiatedRef.current = true;
                                  setSelectedCustomer(val);
                                  
                                  if (val) {
                                    setFieldError("customer", undefined);
                                    if (customerInfo) {
                                      setEnterpriseId(customerInfo.id);
                                      setCustomerTimeZone(customerInfo.timezone);
                                    }
                                    setValues({
                                      ...values,
                                      customer: val,
                                      enterpriseid: newEnterpriseId,
                                    });
                                  } else {
                                    setEnterpriseId("");
                                    setCustomerTimeZone("");
                                    setValues({
                                      ...values,
                                      customer: "",
                                      enterpriseid: "",
                                      addressline1: "",
                                      addressline2: "",
                                      postalcode: "",
                                      country: "",
                                      state: "",
                                      city: "",
                                      number: "",
                                    });
                                    setSiteInitial(emptySiteInitial);
                                    setCountry("");
                                    setState("");
                                    setCity("");
                                    setFilteredStateList([]);
                                    setFilteredCityList([]);
                                  }
                                }}
                              >
                                <option value=''>Select Customer</option>
                                {customers?.length > 0 &&
                                  customers.map((customer: any) => (
                                    <option key={customer.id} value={customer.name}>
                                      {customer.name}
                                    </option>
                                  ))
                                }
                              </Field>
                              <ErrorMessage name="customer">{(error) => <Typography style={{ color: '#f44336', fontSize: "11px" }}>{error}</Typography>}</ErrorMessage>
                            </RBFORM.Group>
                          </Grid>


                          <Grid size={{ xs: 12, md: 6 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Site / Device Name<span style={{ color: "red" }}>*</span></RBFORM.Label>
                              <Field
                                name="name"
                                type="text"
                                component={TextField}
                                className="inputC"
                              >
                              </Field>
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Unique ID<span style={{ color: "red" }}>*</span></RBFORM.Label>
                              <Field
                                name="uniqueid"
                                type="text"
                                placeholder="Enter unique ID"
                                component={TextField}
                                className="inputC"
                              />
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Type<span style={{ color: "red" }}>*</span></RBFORM.Label>
                              <Field
                                name="type"
                                as="select"
                                placeholder="type"
                                className="inputC custDropdown"
                              >
                                <option value="EDGE">EDGE</option>
                                <option value="CLOUD">CLOUD</option>
                              </Field>
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Email ID</RBFORM.Label>
                              <Field
                                name="email"
                                type="text"
                                placeholder="Enter email ID"
                                component={TextField}
                                className="inputC"
                              />
                            </RBFORM.Group>
                          </Grid>

                        </Grid>
                      </Row>

                      <Row className="mb-3" style={{ marginBottom: "70px" }}>
                        <Grid container columnSpacing={3} rowSpacing={0}>
                          {/* <Grid size={{ xs: 12, md: 12 }}>
                        <RBFORM.Group>
                          <RBFORM.Label className="label">Address</RBFORM.Label>
                          <Field
                            name="addressline1"
                            type="text"
                            placeholder="Address Line 1"
                            component={TextField}
                            className="inputC"
                          />
                        </RBFORM.Group>
                      </Grid> */}
                          <Grid size={{ xs: 12, md: 6 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Address Line 1</RBFORM.Label>
                              <Field
                                name="addressline1"
                                type="text"
                                placeholder="Address Line 1"
                                component={TextField}
                                className="inputC"

                              />
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 6 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Address Line 2</RBFORM.Label>
                              <Field
                                name="addressline2"
                                type="text"
                                placeholder="Address Line 2"
                                component={TextField}
                                className="inputC"
                              />
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Country</RBFORM.Label>
                              <Field
                                name="country"
                                as="select"
                                className="inputC custDropdown"
                                onChange={(e: any) => handleCountryChange(e, setFieldValue)}
                              >
                                <option value=''>Select Country</option>
                                {countryList?.length > 0 &&
                                  countryList.filter((country: any) => country.id !== "0" && country.id !== 0).map((country: any) => (
                                    <option key={country.id} value={country.id}>
                                      {country.name}
                                    </option>
                                  ))
                                }
                              </Field>
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">State/Province</RBFORM.Label>
                              <Field
                                name="state"
                                as="select"
                                placeholder="State"
                                className="inputC custDropdown"
                                onChange={(e: any) => { handleStateChange(e, setFieldValue) }}
                              >
                                <option value=''>Select State</option>
                                {filteredStateList?.length > 0 &&
                                  filteredStateList.filter((state: any) => state.id !== "0" && state.id !== 0).map((state: any) => (
                                    <option key={state.id} value={state.id}>
                                      {state.name}
                                    </option>
                                  ))
                                }
                              </Field>
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">City</RBFORM.Label>
                              <Field
                                name="city"
                                as="select"
                                placeholder="City"
                                className="inputC custDropdown"
                                onChange={(e: any) => handleCityChange(e, setFieldValue)}
                              >
                                <option value=''>Select City</option>
                                {filteredCityList?.length > 0 &&
                                  filteredCityList.filter((city: any) => city.id !== "0" && city.id !== 0).map((city: any) => (
                                    <option key={city.id} value={city.id}>
                                      {city.name}
                                    </option>
                                  ))
                                }
                              </Field>
                            </RBFORM.Group>
                          </Grid>

                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Zipcode/Postcode</RBFORM.Label>
                              <Field
                                name="postalcode"
                                type="text"
                                placeholder="Enter Postal Code"
                                component={TextField}
                                className="inputC"
                              />
                            </RBFORM.Group>
                          </Grid>


                          <Grid size={{ xs: 12, md: 4 }}>
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Phone Number</RBFORM.Label>
                              <Field
                                name="number"
                                type="text"
                                placeholder="Phone Number"
                                component={TextField}
                                className="inputC"
                              />
                            </RBFORM.Group>
                          </Grid></Grid>

                        <Grid container columnSpacing={3} rowSpacing={0}>
                          <Grid size={{ xs: 12, md: 4 }} >
                            <RBFORM.Group>
                              <RBFORM.Label className="label">Timezone</RBFORM.Label>
                              <Field
                                name="timezone"
                                as="select"
                                className="inputC custDropdown"
                                onChange={(e: any) => handleTimeZoneChange(e, setFieldValue)}
                                style={{ cursor: "pointer" }}
                              >
                                <option value="" disabled>Select</option>
                                {timezoneList.map((tz) => (
                                  <option key={tz.value} value={tz.value}>
                                    {tz.label}
                                  </option>
                                ))}

                              </Field>
                            </RBFORM.Group>
                          </Grid>
                        </Grid>

                        <div style={{ display: "flex", alignItems: "center" }}>
                          <span>
                            <img src={noteIcon} style={{ width: "20px", height: "20px" }} />
                          </span>
                          <span
                            className="label"
                            style={{ marginLeft: "8px", marginTop: "1.5px", fontSize: "14px", fontWeight: "400" }}
                          >
                            Note: If the timezone is not set at the site level, it will default to the customer’s timezone. If the customer’s timezone is also not set, UTC time will be set as default
                          </span>
                        </div>


                      </Row>
                    </>
                  }
                </>
              )}




              <Stack className="fStacky" direction="row" spacing={2} justifyContent="flex-end"
                sx={{
                  backgroundColor: '#03171F',
                  boxShadow: '-4px -4px 20px #91959621', borderTop: '1px solid #5A5F60', padding: 2,
                }}>
                <Button onClick={() => setOpen(true)} variant="outlined" sx={{ marginRight: 'auto !important', color: '#0699CE', height: '41px', lineHeight: '41px', borderColor: '#0B4A62', borderRadius: '25px', fontSize: '14px', fontWidth: '500', }}>
                  Cancel
                </Button>

                {(() => {
                  const valAny = values as any;
                  const isFormValid = siteType === "1"
                    ? !!(valAny.customer && valAny.orderName?.trim() && valAny.orderRef?.trim() && (userPriority === PROFILE_TYPE.DISTRIBUTOR ? true : valAny.siteId))
                    : !!(valAny.customer && valAny.orderName?.trim() && valAny.orderRef?.trim() && valAny.name?.trim() && valAny.uniqueid?.trim() && valAny.type);

                  return (
                    <Button
                      disabled={isSubmitting || !isFormValid}
                      type="submit"
                      variant="contained"
                      color="primary"
                      startIcon={isSubmitting ? <CircularProgress size="0.9rem" /> : undefined}
                      className={isFormValid ? "btnBlue" : "btnDisable"}
                      sx={{
                        color: isFormValid ? '#1F2F34' : '#0000008A',
                        height: '41px',
                        lineHeight: '41px',
                        borderColor: '#0B4A62',
                        background: isFormValid ? '#17B2EB !important' : '#3D484D !important',
                        borderRadius: '25px',
                        fontSize: '14px',
                        fontWeight: '500',
                        cursor: isFormValid ? 'pointer' : 'not-allowed',
                        '&:hover': {
                          background: isFormValid ? '#17B2EB !important' : '#3D484D !important',
                          opacity: isFormValid ? 0.9 : 1,
                          cursor: isFormValid ? 'pointer' : 'not-allowed',
                        },
                        '&:disabled': {
                          background: '#3D484D !important',
                          color: '#0000008A !important',
                          cursor: 'not-allowed !important',
                        }
                      }}
                      onClick={() => setFieldValue("submitButtonType", "next")}
                    >
                      {isSubmitting ? "Creating..." : "Next"}
                    </Button>
                  );
                })()}
              </Stack>
            </Form>
          </React.Fragment>
        )}
      </Formik >

      <AlertDialogs
        open={open}
        setOpen={setOpen}
        getConfirmResponse={getConfirmResponse}
        title="Cancel Order Creation"
        message="Are you sure want to cancel creating the order?<br/>Any information entered will not be saved.<br/><br/>Click 'Exit' to confirm cancellation."
        button1="Continue Editing"
        button2="Exit"
      />
    </>
  )
}

export default OrderCreateStep1SiteDevice